export default {
  computed: {
    pointFields() {
      return [
        {
          key: 'drag',
          label: '',
        },
        {
          name: 'address',
          key: 'address',
          label: this.$t('global.field.location'),
          placeholder: this.$t('fleetTaskInstant.placeholder.searchDestination'),
          type: 'text',
          validation: 'required',
          validationMessages: {
            required: this.$t('fleetTaskInstant.input.error.address.required'),
          },
          isEditable: true,
          thStyle: 'min-width:300px',
        },
        {
          name: 'target_time_arrival',
          key: 'target_time_arrival',
          label: this.$t('fleetTaskInstant.field.arrivalTarget'),
          placeholder: this.$t('fleetTaskInstant.placeholder.datetime'),
          type: 'date-picker',
          datepickerType: 'datetime',
          valueType: 'YYYY-MM-DDTHH:mm:ssZ',
          format: 'DD/MM/YYYY HH:mm',
          confirm: true,
          confirmText: this.$t('global.action.apply'),
          thStyle: 'width:250px',
        },
        {
          name: 'service_time',
          key: 'service_time',
          label: this.$t('fleetTaskInstant.field.activityDuration'),
          placeholder: `00 ${this.$t('global.text.time.hour')} 00 ${this.$t(
            'global.text.time.minute'
          )}`,
          type: 'time-duration',
          isFixed: true,
          initialValues: {
            hours: 0,
            minutes: 15,
          },
          optionItems: [
            {
              key: 'hours',
              items: Array.from({ length: 24 }, (_, i) => i),
            },
            {
              key: 'minutes',
              items: Array.from({ length: 60 }, (_, i) => i),
            },
          ],
          thStyle: 'width:200px',
        },
        {
          name: 'target_time_departure',
          key: 'target_time_departure',
          label: this.$t('fleetTaskInstant.field.departureTarget'),
          placeholder: this.$t('fleetTaskInstant.placeholder.datetime'),
          type: 'date-picker',
          datepickerType: 'datetime',
          valueType: 'YYYY-MM-DDTHH:mm:ssZ',
          format: 'DD/MM/YYYY HH:mm',
          confirm: true,
          confirmText: this.$t('global.action.apply'),
          thStyle: 'width:250px',
        },
        {
          name: 'activity_label',
          key: 'activity_label',
          label: this.$t('global.activity'),
          type: 'pick-button',
          thStyle: 'width:220px',
        },
        {
          name: 'note',
          key: 'note',
          label: this.$t('fleetTaskInstant.field.locationNote'),
          placeholder: this.$t('fleetTaskInstant.placeholder.locationNote'),
          type: 'text',
          isEditable: true,
          thStyle: 'width:250px',
          validation: 'max:255,length',
        },
      ]
    },
  },
}
